module.exports = __webpack_public_path__ + "static/img/icon-1.a44b58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/icon-1.png
// module id = AlpJ
// module chunks = 0